<div class="container flex flex-row justify-center p-4">
  <a mat-button
     [href]="urlFacebook"
     class="facebook"
     target="blank">
    <span class="fa fa-facebook"></span>
  </a>

  <a mat-button
     [href]="urlTwitter"
     class="twitter px-6 pb-0 mx-4"
     target="blank">
    <span class="fa fa-twitter"></span>
  </a>

  <a mat-button
     [href]="urlLinkedIn"
     class="linkedin px-6 pb-0"
     target="blank">
    <span class="fa fa-linkedin"></span>
  </a>
</div>
